import {
    NinchatActionType,
    NinchatDescribeChannelAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatChannelFoundEvent} from 'api/types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const describeChannel = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeChannelAction}`,
    async (arg: NinchatActionParams<NinchatDescribeChannelAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDescribeChannelAction

        try {
            return await ninchatClient.send(params) as NinchatChannelFoundEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
